import { LoggingModule } from 'services/Logger';

interface AccountNames {
  currentAccountFirstName: string;
  mainAccountFirstName: string;
}

export default {
  MODAL_TEXT: {
    title: 'User Ineligible',
    slug: ({ currentAccountFirstName, mainAccountFirstName }: AccountNames) => {
      const firstLine = currentAccountFirstName
        ? `We noticed you are viewing as ${currentAccountFirstName}. \n`
        : '';
      return `${firstLine}E-Visits can only be used for the primary account holder, ${mainAccountFirstName}.`;
    },
    severity: 'warning',
    confirm: 'Switch to my profile',
    decline: 'Exit'
  },
  ERROR: {
    title: 'Unable to switch accounts',
    severity: 'error',
    text: 'Ok',
    description:
      'Sorry, we ran into a problem switching to your profile. Please try again through the profile screen.',
    LOGGER: {
      title: `${LoggingModule.switchAccount}Failed to switch account`,
      consumerNotFound: 'Could not find consumerId'
    }
  },
  SUCCESS: {
    LOGGER: {
      source: 'E-Visit Proxy Warning'
    }
  }
};
